import React from 'react';
import { useSettingMode } from 'state/hook';
import './style.scss';

interface SwitchNetworkProps {
  padding?: string;
}

const SwitchNetworkList: React.FC<SwitchNetworkProps> = ({ padding ='8px 25px' }) => {

	const { spaceMode, muteMode } = useSettingMode();
	const query = `&t=${spaceMode ? '1' : '0'}&s=${muteMode ? '1' : '0'}`;

	const isAlpha = process.env.REACT_APP_ENV === 'alpha';

	return (
    <div>
      <a
        className="flex flex-col network-btn-wrap2"
        style={{ padding }}
        href={`https://${
        isAlpha ? 'alpha' : 'www'
      }.wardenswap.finance/#/best-rate-swap?network=ethereum${query}`}
      >
        <div className="flex items-center">
          <div className="relative mr-5">
            <img
              src='/images/icon-eth-round.svg'
              alt="icon-network"
              width="25"
            />
          </div>
          <span>
            Ethereum
          </span>
        </div>
      </a>
      <div
        className="flex flex-col network-btn-wrap2"
        style={{ padding }}
      >
        <div className="flex items-center">
          <div className="relative mr-5">
            <img
              src='/images/icon-bsc-round.svg'
              alt="icon-network"
              width="25"
            />
            <img
              src="/images/icon-check.svg"
              alt="icon-check"
              className="w-15px absolute icon-check-position"
            />
          </div>
          <span className="network-active">
            BNB Chain
          </span>
        </div>
      </div>
      <a
        className="flex flex-col network-btn-wrap2"
        style={{ padding }}
        href={`https://${
        isAlpha ? 'alpha' : 'www'
      }.wardenswap.finance/#/best-rate-swap?network=polygon${query}`}
      >
        <div className="flex items-center">
          <div className="relative mr-5">
            <img
              src='/images/icon-polygon-round.svg'
              alt="icon-network"
              width="25"
            />
          </div>
          <span>
            Polygon
          </span>
        </div>
      </a>
      <a
        className="flex flex-col network-btn-wrap2"
        style={{ padding }}
        href={`https://${
        isAlpha ? 'alpha' : 'www'
      }.wardenswap.finance/#/best-rate-swap?network=avalanche${query}`}
      >
        <div className="flex items-center">
          <div className="relative mr-5">
            <img
              src='/images/icon-avalanche-round.svg'
              alt="icon-network"
              width="25"
            />
          </div>
          <span>
            Avalanche
          </span>
        </div>
      </a>
      <a
        className="flex flex-col network-btn-wrap2"
        style={{ padding }}
        href={`https://${
        isAlpha ? 'alpha' : 'www'
      }.wardenswap.finance/#/best-rate-swap?network=arbitrum${query}`}
      >
        <div className="flex items-center">
          <div className="relative mr-5">
            <img
              src='/images/icon-arbitrum-round.svg'
              alt="icon-network"
              width="25"
            />
          </div>
          <span>
            Arbitrum
          </span>
          <div className="blockchain-layer-wrap">
            <p>L2</p>
          </div>
        </div>
      </a>
      <a
        className="flex flex-col network-btn-wrap2"
        style={{ padding }}
        href={`https://${
        isAlpha ? 'alpha' : 'www'
      }.wardenswap.finance/#/best-rate-swap?network=optimism${query}`}
      >
        <div className="flex items-center">
          <div className="relative mr-5">
            <img
              src='/images/icon-optimism-round.svg'
              alt="icon-network"
              width="25"
            />
          </div>
          <span>
            Optimism
          </span>
          <div className="blockchain-layer-wrap">
            <p>L2</p>
          </div>
        </div>
      </a>
    </div>
	);
};

export default SwitchNetworkList;
